export class WorkflowInstanceStepCommentModel {
  comment?: string | null;
  commentCreated?: Date | null;
  commentCreatedBy?: string | null;

  static fromData(data: any): WorkflowInstanceStepCommentModel | undefined {
    if (!data) return undefined;
    const m = new WorkflowInstanceStepCommentModel();
    m.comment = data.comment ?? null;
    m.commentCreated = data.commentCreated ? new Date(data.commentCreated) : null;
    m.commentCreatedBy = data.commentCreatedBy ?? null;
    return m;
  }
}
